import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import Icon from 'components/Icon';
import LinkButton from 'components/LinkButton';
import TableStatic from 'components/Table/TableStatic';
import {boolToIconString} from 'utils/functions';
import {notificationTable} from '../styles.module.css';
import {User} from '../types';

type UserProps = {user: User};

const UserTable: FC<UserProps> = ({user}) => {
    const {t} = useTranslation('Profile.Notification');

    return (
        <TableStatic
            className={clsx(notificationTable, 'mt-6 w-full min-w-[720px]')}
            hasStripes={true}
            id="user-table"
        >
            <TableStatic.Header>
                <TableStatic.HeaderRow>
                    <TableStatic.Column>
                        {t('userNotifications')} - {user.email}
                    </TableStatic.Column>
                    <TableStatic.Column className="gap-2">
                        <LinkButton
                            href={window.Urls.email_settings_view()}
                            kind="secondary"
                            size="xs"
                        >
                            {t('manageEmails')}
                        </LinkButton>
                        <LinkButton
                            href={window.Urls.notifications_edit_view()}
                            kind="secondary"
                            size="xs"
                        >
                            {t('editNotificationSettings')}
                        </LinkButton>
                    </TableStatic.Column>
                </TableStatic.HeaderRow>
            </TableStatic.Header>
            <TableStatic.Body>
                <TableStatic.Row>
                    <TableStatic.Cell>
                        {t('systemNotifications')} -{' '}
                        {t('systemNotificationsDescription')}
                    </TableStatic.Cell>
                    <TableStatic.Cell>
                        <Icon icon="enabled_checkbox" size="base" />
                    </TableStatic.Cell>
                </TableStatic.Row>
                <TableStatic.Row>
                    <TableStatic.Cell>
                        {t('announcements')} - {t('announcementsDescription')}
                    </TableStatic.Cell>
                    <TableStatic.Cell>
                        <Icon
                            icon={boolToIconString(
                                user.settings.isNewsletterEnabled,
                            )}
                            size="base"
                        />
                    </TableStatic.Cell>
                </TableStatic.Row>
                <TableStatic.Row>
                    <TableStatic.Cell>
                        {t('onboarding')} - {t('onboardingDescription')}
                    </TableStatic.Cell>
                    <TableStatic.Cell>
                        <Icon
                            icon={boolToIconString(
                                user.settings.isOnboardingEnabled,
                            )}
                            size="base"
                        />
                    </TableStatic.Cell>
                </TableStatic.Row>
            </TableStatic.Body>
        </TableStatic>
    );
};

export default UserTable;
